/// JTF3-added-AB-22-05-12

jQuery(document).ready(function($) {
	function QUICKLINKS() {
		console.log('JTF QuickLinks V1.0.31')
		this.quickLinksContainer = $('.jtf__quicklinksblock--links');
		this.title = $('.jtf__quicklinksblock--title');
		this.block = $('.wp-block-jtf-jtf-quicklinks');
		this.init();
	}
	
	/**
	 * Sets the width of the links part of the quicklinks bar - sets it to be 100% minus the width of the title part
	 * @param action
	 */
	QUICKLINKS.prototype.resetWidth = function ( action ) {
		const self = this;
		const titleWidth = self.title.width() + 30;

		// if ( action == true ) {
		// 	self.quickLinksContainer.css({
		// 		width: 'calc(100% - ' + titleWidth + 'px)'
		// 	});
		// } else {
		// 	self.quickLinksContainer.css({
		// 		width: '100%'
		// 	});
		// }
	}

	/**
	 * Default actions happening on device actions
	 */
	QUICKLINKS.prototype.init = function () {
		const self = this;
		// Wipe the placeholder text from the container before populating it with links
		//self.quickLinksContainer.html('');
		// set the width of the links part on first load
		self.resetWidth(true);
		// Scan all blocks to look for id's - if one is found, add it to the main quicklinks list
		$('.jtf__block').each(function() {
			const targetId 	= $(this).attr('id');
			const targetCopy 	= $(this).attr('data-copy');

			if ( targetId && targetCopy ) {
				self.quickLinksContainer.append('<a href="#' + targetId + '">' + targetCopy + '</a>');
			}
		});

		self.quickLinksContainer.find('a[href*=\\#]').not('.returntotop__container').on('click', function(e) {
			e.preventDefault();
			self.quickLinksContainer.removeClass('jtf__quicklinksblock--links-open')
			
			$('html, body').animate({
				scrollTop: $(this.hash).offset().top-150
			}, 500);
		});

		// Update the locked state on scroll
		// adds locked state if browser scroll position is lower or equal to the top of the quicklinks container
		$(document).scroll(function() {
			const topOfParent = self.block.offset().top;
			//+100 to this to account for navbars etc at the top, and the quicklinks menu if its open
			//TODO ADDING 200 TO THIS MAKES IT GO WEIRD WHEN ITS NOT OPEN
			//HAVE IT ADD 200 ONLY IF THE MENU IS OPEN
			//const currentScrollPosition = $(document).scrollTop() + 200;
			const currentScrollPosition = $(document).scrollTop();
			// console.log(currentScrollPosition,topOfParent)
			
			$('.jtf__quicklinksblock').each(function() {
				const targetId 	= $(this).attr('id');
				let offset = $(this).offset()
				
				if ( targetId ) {
					//console.log( offset.top, currentScrollPosition)
					if ( offset.top <= currentScrollPosition && currentScrollPosition <= offset.top + $(this).height() ) {
						//if we match, find the quicklinks link with the href value that matches this blocks ID
						$('[href=#'+targetId+']').addClass('jtf__quicklinksblock--infocus')
					} else {
						$('[href=#'+targetId+']').removeClass('jtf__quicklinksblock--infocus')
					}
				}
				
			});

			if ( currentScrollPosition >= topOfParent ) {
				self.block.addClass('jtf__quicklinksblock--locked')
				self.resetWidth(false)
			} else {
				self.block.removeClass('jtf__quicklinksblock--locked')
				self.resetWidth(true)
			}
		});

		// goggle state of dropdown
		self.title.click(function() {
			self.quickLinksContainer.toggleClass('jtf__quicklinksblock--links-open')
		});

		// reset the width on document resize - stops the forced width calc on desktop breaking mobile
		$(window).resize(function() {
			self.resetWidth(true)
		})
	};

	// check QUICKLINKS is used on this page before instantiating
	if ($('.wp-block-jtf-jtf-quicklinks').length > 0) {
		const quickLink = new QUICKLINKS();
	}
});

